<template>
    <div class="vertical-container">
        <div class="vertical-container__header vertical-container__header--has-shadow fullwidth-container">
            <div class="container">
                <h1>Rychlý přehled</h1>
            </div>
        </div>

        <div class="vertical-container__content fullwidth-container">
            <elementary-section class="elementary-section--full">
                <div class="container">
                    <div class="plan" v-if="isTrial">
                        <div class="plan__heading">
                            <strong>Právě využíváte zkušební verzi aplikace.</strong>
                        </div>
                        <p>
                            Pro přechod na plnou verzi nás kontaktujte na
                            <a href="mailto:katerina.sudova@domovio.cz?subject=Přechod na placenou verzi"
                               target="_blank">katerina.sudova@domovio.cz</a>.
                        </p>
                    </div>

                    <div class="dashboard">
                        <unit-quick-choice/>
                        <interest-list/>
                        <newsletter-list/>
                    </div>

                    <subscription-plan v-if="!isTrial"/>
                </div>
            </elementary-section>
        </div>
    </div>
</template>
<script>
import ElementarySection from '@/components/Content/ElementarySection';
import UnitQuickChoice from '@/modules/ProjectModule/components/Dashboard/UnitQuickChoice';
import InterestList from '@/modules/ProjectModule/components/Dashboard/InterestList';
import NewsletterList from '@/modules/ProjectModule/components/Dashboard/NewsletterList';
import SubscriptionPlan from '@/modules/ProjectModule/components/Dashboard/SubscriptionPlan';

export default {
    components: {SubscriptionPlan, NewsletterList, InterestList, UnitQuickChoice, ElementarySection},
    computed:   {
        isTrial() {
            return this.$store.getters['projects/project/subscription/isTrial'];
        }
    }
}
</script>
